import { CountryCode } from './country-codes';

export enum SupportedLanguage {
  ENGLISH = 'en',
  HINDI = 'hi',
  TAMIL = 'ta',
}

export const languageToCodes: Record<string, string> = {
  Hindi: 'hi',
  English: 'en',
  Tamil: 'ta',
} as const;

export const codesToLanguage: Record<string, string> = {
  hi: 'Hindi',
  en: 'English',
  ta: 'Tamil',
} as const;

export type SupportedCurrency = 'INR' | 'USD' | 'IDR' | 'KWD';

export interface I18nConfig {
  language: SupportedLanguage;
  currency: SupportedCurrency;
  timezone: string;
  countryCode: CountryCode;
}
